<div class="bg-pic w-full h-full" [ngStyle]="{'background': 'url(' + fondoRecuperar + ')'}" fxLayout="column" fxLayoutAlign="center center">
    <div @fadeInUp class="card overflow-hidden w-full max-w-xs">
        <div class="p-6 pb-0" fxLayout="column" fxLayoutAlign="center center">
            <!-- * Logotipo * -->
            <div class="fill-current text-center">
                <img class="logoLogin" src="assets/img/demo/logo.png">
            </div>
        </div>

        <!-- * Mensaje * -->
        <div class="text-center mt-4">
            <h2 class="title m-0">Recupera tu contraseña</h2>
        </div>


        <div [formGroup]="form"  class="p-6" fxLayout="column" fxLayoutGap="16px">
            <div fxFlex="auto" fxLayout="column">
                <mat-form-field fxFlex="grow">
                    <mat-label>Correo electrónico</mat-label>
                    <input formControlName="username" [(ngModel)]="username" matInput required (keyup.enter)="solicitarRecuperacion()">
                </mat-form-field>
                <mat-form-field fxFlex="grow" *ngIf="correoEnviado">
                    <mat-label>Código de seguridad</mat-label>
                    <input formControlName="codigoSeguridad" matInput required [(ngModel)]="codigoSeguridad">
                </mat-form-field>
                <mat-form-field fxFlex="grow" *ngIf="correoEnviado">
                    <mat-label>Nueva contraseña</mat-label>
                    <input formControlName="password" [type]="inputType" matInput [(ngModel)]="password" required>
                    <button (click)="toggleVisibility()" mat-icon-button matSuffix matTooltip="Toggle Visibility" type="button">
                        <mat-icon *ngIf="visible" [icIcon]="icVisibility"></mat-icon>
                        <mat-icon *ngIf="!visible" [icIcon]="icVisibilityOff"></mat-icon>
                    </button>
                    <mat-error *ngIf="form.get('password').hasError('required')">Necesita una contraseña para ingresar</mat-error>
                </mat-form-field>
            </div>

            <mat-progress-bar *ngIf="cargando" mode="indeterminate" color="primary"></mat-progress-bar>
            <button (click)="solicitarRecuperacion()" color="primary" mat-raised-button type="button" [disabled]="cargando" *ngIf="!correoEnviado">
                Recuperar mi contraseña
            </button>
            <button (click)="recuperarCodigoSeguridad()" color="primary" mat-raised-button type="button" [disabled]="cargando" *ngIf="correoEnviado">
                Reiniciar contraseña
            </button>

        </div>
    </div>
</div>